import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VisibleFiltersState {
  [key: string]: string[];
}

const initialState: VisibleFiltersState = {};

const visibleFiltersSlice = createSlice({
  name: 'visibleFilters',
  initialState,
  reducers: {
    setVisibleFilters(
      state,
      action: PayloadAction<{ page: string; filters: string[] }>
    ) {
      const { page, filters } = action.payload;
      state[page] = filters;
    },

    initVisibleFilters(
      state,
      action: PayloadAction<{
        page: string;
        allFilters: string[];
        isSupport: boolean;
        supportExcluded?: string[];
      }>
    ) {
      const {
        page,
        allFilters,
        isSupport,
        supportExcluded = [],
      } = action.payload;

      if (!state[page]) {
        state[page] = isSupport
          ? allFilters.filter(f => !supportExcluded.includes(f))
          : allFilters;
      }
    },
  },
});

export const { setVisibleFilters, initVisibleFilters } =
  visibleFiltersSlice.actions;
export default visibleFiltersSlice.reducer;
